import script from "./ConfirmComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__